<span [style.background-color]="user?.subcontractorBgColor" [style.color]="user?.subcontractorFgColor" class="mf-sub-icon">
    {{ user | userTag }}
</span>
